<template>
  <div class="box main-box is-radiusless is-shadowless" style="position: relative">
    <h2>Payment Card</h2>
    <b-field class="section-title">
      <template v-if="!formIsEditable">
        <div class="payment-card-content"
             :class="[isCardDataEmpty ? 'min-content' : 'max-content']">
          <template v-if="isCardDataEmpty">
            <span class="payment-card-empty">Add a card to pay for Enhancify</span>
          </template>
          <template v-else>
            <div class="card-info">
              <div class="card-info-brand-number-expiration">
                <div class="brand-number">
                  <img class="card-info-brand" :src="getIcon(frmCardBrand)"
                       width="80" alt="brand card">
                  <span class="card-info-card-number">{{ frmCardNumber }}</span>
                </div>
                <div>
                  <span>Expiration:</span>
                  <span :class="{'card-info-expiration-alert':isExpired }">
                  {{ frmCardExpiration }}
                </span>
                </div>
              </div>
                <p v-if="!formIsEditable" :class="{'card-info-expiration-alert':
            getExpireMessage(this.cardData.expireMonth,this.cardData.expireYear).length > 0 }">
                  {{ getExpireMessage(this.cardData.expireMonth,this.cardData.expireYear) }}</p>
            </div>
          </template>
          <div class="buttons add-update-btns"
               :class="[isCardDataEmpty ? 'min-content' : 'max-content']">
            <template v-if="isCardDataEmpty">
              <b-button class="button is-success" @click="cardActivated()">
                Add card
              </b-button>
            </template>
            <template v-else>
              <b-button class="button is-success" @click="cardActivated(true)">
                Update card
              </b-button>
            </template>
          </div>
        </div>
      </template>
    </b-field>
    <b-field></b-field>
    <template v-if="formIsEditable">
      <validation-observer ref="updateCardObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(frmUpdateCard)">
          <div class="payment-card-form field is-grouped-multiline">
            <div class="name-number-card">
              <div class="cardholder-name-wrapper">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|max:255"
                  mode="passive"
                  name="Cardholder name">
                  <b-field :type="{'is-danger': errors.length }" :message="errors"
                           custom-class="is-size-6 has-text-weight-normal"
                           label="Cardholder name">
                    <template slot="label">
                      Cardholder name
                    </template>
                    <div class="control" :class="{'has-icons-right': errors.length}">
                      <input v-model="frmCardName"
                             class="input"
                             placeholder="Name on card"
                             :class="{'is-danger': errors.length}">
                      <span v-if="errors.length" class="icon is-right has-text-danger">
                        <i class="mdi mdi-alert-circle mdi-24px"></i>
                      </span>
                    </div>
                  </b-field>
                </validation-provider>
              </div>
              <div class="card-number-wrapper">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required|card_number"
                  mode="passive"
                >
                  <b-field :type="{'is-danger': errors.length }"
                           custom-class="is-size-6 has-text-weight-normal"
                           :message="errors">
                    <template slot="label">
                      Card number
                    </template>
                    <div class="control" :class="{'has-icons-right': errors.length}">
                      <input v-model="frmCardNumber"
                             class="input"
                             placeholder="4242 4242 4242 4242"
                             maxlength="23"
                             v-mask="'#### #### #### #### ###'"
                             :class="{'is-danger': errors.length}"
                      >
                      <span v-if="errors.length" class="icon is-right has-text-danger">
                    <i class="mdi mdi-alert-circle mdi-24px"></i>
                  </span>
                    </div>
                  </b-field>
                </validation-provider>
              </div>
            </div>
            <div class="expiration-cvc-zip">
              <div class="expiration-field-wrapper">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{required: true, card_expiration: true}"
                  maxlength="5"
                  mode="passive">
                  <b-field :type="{'is-danger': errors.length }"
                           custom-class="is-size-6 has-text-weight-normal"
                           :message="errors">
                    <template slot="label">
                      Expiration
                    </template>
                    <div class="control" :class="{'has-icons-right': errors.length}">
                      <input v-model="frmCardExpiration"
                             placeholder="mm/yy"
                             class="input"
                             maxlength="5"
                             v-mask="'##/##'"
                             :class="{'is-danger': errors.length}">
                      <span v-if="errors.length" class="icon is-right has-text-danger">
                    <i class="mdi mdi-alert-circle mdi-24px"></i>
                  </span>
                    </div>
                  </b-field>
                </validation-provider>
              </div>
              <div class="cvc-field-wrapper">
                <validation-provider
                  name="CVC"
                  v-slot="{ errors }"
                  :rules="{required: true, regex: /^[0-9]{3,4}/ }"
                  mode="passive">
                  <b-field :type="{'is-danger': errors.length }"
                           custom-class="is-size-6 has-text-weight-normal"
                           :message="errors">
                    <template slot="label">
                      CVC
                      <b-tooltip
                        class="cvc-tooltip"
                        :delay="parseInt('200')"
                        animated
                        multilined>
                      <span class="icon is-small enhicon"><i class="mdi mdi-help-circle"></i></span>
                      </b-tooltip>
                    </template>
                    <div class="control" :class="{'has-icons-right': errors.length}">
                      <input
                        v-model="frmCardCVC"
                        class="input"
                        maxlength="4"
                        v-mask="'####'"
                        placeholder="3-4 digits"
                        :class="{'is-danger': errors.length}">
                      <span v-if="errors.length" class="icon is-right has-text-danger">
                    <i class="mdi mdi-alert-circle mdi-24px"></i>
                  </span>
                    </div>
                  </b-field>
                </validation-provider>
              </div>
              <div class="zip-field-wrapper">
                <validation-provider
                  v-slot="{ errors }"
                  :rules="{ required: true, zip_code: true}"
                  mode="passive">
                  <b-field :type="{'is-danger': errors.length }"
                           custom-class="is-size-6 has-text-weight-normal"
                           :message="errors">
                    <template slot="label">
                      Zip code
                      <b-tooltip
                        label="Zip you gave the bank as your mailing address"
                        :delay="parseInt('200')"
                        animated
                        multilined>
                      <span class="tooltip-info-icon icon is-small enhicon">
                        <i class="mdi mdi-help-circle"></i></span>
                      </b-tooltip>
                    </template>
                    <div class="control" :class="{'has-icons-right': errors.length}">
                      <input
                        v-model="frmCardZIP"
                        class="input"
                        maxlength="5"
                        v-mask="'#####'"
                        placeholder="ZIP"
                        :class="{'is-danger': errors.length}">
                      <span v-if="errors.length" class="icon is-right has-text-danger">
                        <i class="mdi mdi-alert-circle mdi-24px"></i>
                      </span>
                    </div>
                  </b-field>
                </validation-provider>
              </div>
            </div>
          </div>
          <div class="buttons is-grouped upd-cancel-btns">
            <b-button class="button is-success is-outlined" @click="setNotEditable" outlined>
              Cancel
            </b-button>
            <template v-if="!isCardDataEmpty">
              <b-button
                :disabled="disabledBtn"
                :class="{'is-disabled':disabledBtn}"
                class="button is-success" @click="handleSubmit(frmUpdateCard)">
                Update
              </b-button>
            </template>
            <template v-else>
              <b-button
                :disabled="disabledBtn"
                :class="{'is-disabled':disabledBtn}"
                class="button is-success add-card-btn" @click="handleSubmit(frmCreateCard)">
                Add
              </b-button>
            </template>
          </div>
        </form>
      </validation-observer>
    </template>
    <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import {
  getUserCard, userActionWithCard,
} from '@/api/card_payments';
import { VueMaskDirective } from 'v-mask';

export default {
  name: 'ContractorCards',
  directives: { mask: VueMaskDirective },
  data() {
    return {
      cardData: [],
      isLoading: false,
      frmCardNumber: '',
      frmCardName: '',
      frmCardExpiration: '',
      frmCardCVC: '',
      frmCardZIP: '',
      frmCardBrand: '',
      isExpired: false,
      formIsEditable: false,
      isUpdateMode: false,
      hasImmediateActionDone: false,
    };
  },
  props: {
    addCardImmediately: {
      type: Boolean,
      default: false,
    },
    updateCardImmediately: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id }),
    ...mapGetters(['isSwitched', 'userAuthenticator', 'authAuthenticator']),
    ...mapGetters('card', ['cardIcon']),
    isCardDataEmpty() {
      return this.cardData.length === 0;
    },
    disabledBtn() {
      return !!(_.isEmpty(this.frmCardName) || _.isEmpty(this.frmCardNumber)
        || _.isEmpty(this.frmCardExpiration) || _.isEmpty(this.frmCardCVC)
        || _.isEmpty(this.frmCardZIP));
    },
  },
  activated() {
    this.loadCardData();
  },
  deactivated() {
    this.formIsEditable = false;
    this.hasImmediateActionDone = false;
  },

  methods: {
    cardActivated(update = false) {
      this.formIsEditable = true;
      this.isUpdateMode = update;
      this.frmCardNumber = '';
      this.frmCardCVC = '';
      this.frmCardName = '';
      this.frmCardExpiration = '';
      this.frmCardZIP = '';
    },
    setNotEditable() {
      this.formIsEditable = false;
      this.frmCardName = this.cardData.cardholderName;
      this.frmCardNumber = this.cardData.number;
      this.frmCardExpiration = `${this.monthToStr(this.cardData.expireMonth)}/${String(this.cardData.expireYear).substring(2)}`;
      this.frmCardZIP = this.cardData.zipCode;
      this.frmCardCVC = '';
    },
    loadCardData() {
      this.isLoading = true;
      getUserCard(this.userId)
        .then((response) => {
          this.cardData = response.data;
          this.frmCardName = response.data.cardholderName;
          this.frmCardNumber = response.data.number;
          this.frmCardBrand = response.data.brand;
          this.frmCardZIP = response.data.zipCode;
          this.frmCardExpiration = `${this.monthToStr(response.data.expireMonth)}/${String(response.data.expireYear).substring(2)}`;
          if (
            (this.addCardImmediately || this.updateCardImmediately)
              && !this.hasImmediateActionDone
          ) {
            this.cardActivated(this.updateCardImmediately);
            this.hasImmediateActionDone = true;
          }
        })
        .catch((error) => {
          this.error = error;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    async frmCreateCard() {
      const valid = await this.$refs.updateCardObserver.validate();
      if (valid) {
        this.isLoading = true;
        userActionWithCard(this.userId, 'create', {
          number: this.frmCardNumber,
          name: this.frmCardName,
          expiration: this.frmCardExpiration,
          cvc: this.frmCardCVC,
          address_zip: this.frmCardZIP,
        })
          .then((response) => {
            if (response.data.error) {
              this.toast(response.data.message, 'is-danger');
            } else {
              this.formIsEditable = false;
              this.toast('Card added successfully');
              this.loadCardData();
            }
          })
          .catch((error) => {
            this.toast(this.lodash.get(error, 'response.data.message', 'Undefined error'), 'is-danger');
            this.error = error;
          })
          .finally(() => {
            this.isLoading = false;
          });
        return true;
      }
      return false;
    },

    async frmUpdateCard() {
      const valid = await this.$refs.updateCardObserver.validate();
      if (valid) {
        this.isLoading = true;
        userActionWithCard(this.userId, 'update', {
          number: this.frmCardNumber,
          name: this.frmCardName,
          expiration: this.frmCardExpiration,
          cvc: this.frmCardCVC,
          address_zip: this.frmCardZIP,
        })
          .then((response) => {
            if (response.data.error) {
              this.toast(response.data.message, 'is-danger');
            } else {
              this.formIsEditable = false;
              this.toast('Card updated successfully');
              this.loadCardData();
            }
          })
          .catch((error) => {
            this.toast(this.lodash.get(error, 'response.data.message', 'Undefined error'), 'is-danger');
            this.error = error;
          })
          .finally(() => {
            this.isLoading = false;
          });
        return true;
      }
      return false;
    },
    toast(message, type = 'is-success') {
      this.$buefy.toast.open({ message, type, duration: 5000 });
    },

    monthToStr(month) {
      let suff = '';
      if (month < 10) {
        suff = '0';
      }
      return suff + month;
    },

    getIcon(brand) {
      return `/img/card/${this.cardIcon(brand)}`;
    },

    getExpireMessage(month, year) {
      const dt = new Date();
      const expDate = new Date(year, month, 0);
      const diffDays = Math.floor((expDate - dt) / (1000 * 60 * 60 * 24));
      if (diffDays < 0) {
        this.isExpired = true;
        return 'Your card has expired';
      }
      if (diffDays <= 30) {
        this.isExpired = false;
        return 'Your card is expiring soon';
      }
      this.isExpired = false;
      return '';
    },
  },
};
</script>

<style scoped lang="stylus">
.control > input.input::placeholder
  color #8A9499
.icon.is-small.enhicon
  cursor help
.payment-card-form.field.is-grouped-multiline
  display grid
  grid-row-gap 20px
  margin-bottom 20px
.add-card-btn
  min-width: 96px;
.expiration-field-wrapper
  min-width: 121px
.cvc-field-wrapper
  min-width: 135px
.cardholder-name-wrapper, .card-number-wrapper
  min-width: 235px;
.expiration-cvc-zip
  display: grid;
  gap: 20px;
  justify-items: start;
  grid-template-columns: repeat(auto-fit, minmax(135px, 135px));
  @media screen and (max-width: 768px)
    grid-template-columns: repeat(3, minmax(135px, 100%));
  @media screen and (max-width: 535px)
    grid-template-columns: repeat(2, minmax(135px, 100%));
  @media screen and (max-width: 377px)
    grid-template-columns: repeat(1, minmax(100%, 100%));
    .expiration-field-wrapper,.cvc-field-wrapper,.zip-field-wrapper
      width 100%
.name-number-card
  display grid
  gap 20px
  justify-items: start;
  grid-template-columns: repeat(auto-fit, minmax(240px, 240px));
  @media screen and (max-width: 768px)
    grid-template-columns: repeat(2, minmax(240px, 100%));
    .cardholder-name-wrapper,.card-number-wrapper
      width 100%
  @media screen and (max-width: 595px)
    grid-template-columns: repeat(1, minmax(100%, 100%));
    .cardholder-name-wrapper, .card-number-wrapper
      min-width: unset;

.is-danger.input
  border-color #ff3860!important
.button.button.is-success:hover:not(.is-disabled)
  background-color #17b548
  border-color #17b548
.button.button.is-success
  text-transform uppercase
.button.button.is-success:not(.is-disabled,.is-outlined)
  background-color #68BA62
.button.button.is-success.is-outlined:focus
  background-color #17b548
  border-color #17b548
span.icon.has-text-info.is-small
  height inherit
.box.main-box
  outline: 1px solid #80808059
.upd-cancel-btns
  justify-content end
  @supports (-webkit-hyphens:none)
    -webkit-justify-content flex-end

.payment-card-content
  display grid
  gap: 10px;
  align-items start

.buttons.add-update-btns.max-content
  justify-self end
@media screen and (min-width: 430px)
  .card-info
    grid-column 1/3
  .field.section-title > div.payment-card-content.max-content
    grid-template-columns 170px auto 147px;
  .buttons.add-update-btns.max-content
    grid-column-start 3
.buttons.add-update-btns.min-content
  grid-column-start 2
  justify-self end

.brand-number
  display grid
  grid-template-columns 80px 80px
  align-items center
  grid-column-gap 10px
.card-info-expiration-alert
  color red
.payment-card-empty
  align-self center
.card-info-brand-number-expiration
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 170px));
  align-items: center;
  grid-row-gap: 10px;
  margin-bottom: 10px;

.b-tooltip.is-animated.is-medium.is-multiline.is-top.cvc-tooltip:hover::after
  background url("/img/card/payment-card-sample.png")
  background-position center
  background-size contain
  height 80px
  width 210px
  border 1px solid #525f66
  @media screen and (max-width: 377px)
    left 60px
  @media screen and (min-width: 769px) and (max-width 907px)
    left 60px

.brand_column
.number_column
  width 100px

.b-table
  margin 5px
  margin-bottom 1rem
  -webkit-box-shadow 0 0 20px 1px rgba(0, 0, 0, 0.1)
  -moz-box-shadow 0 0 20px 1px rgba(0, 0, 0, 0.1)
  box-shadow 0 0 20px 1px rgba(0, 0, 0, 0.1)

  td:nth-child(even)
    background-color inherit

  tr:nth-child(even) td
    background-color #f2f5f6

.grid-block__footer
  margin-bottom 2rem

.default-card
  color #23d160

.action-column
  text-align right
  width 100px

  .icon
    color #23d160
    display inline-block
    margin 5px
    cursor pointer

  .action-button
    display inline-block
    margin 0 .5rem

.card-form
  background-color white
  overflow auto

  &__panel
    text-align right

  h2
    color #447086
    font-weight bold
    font-size 1rem
    margin-bottom 1rem

.row
  display flex
  flex-direction row
  align-items center

  img
    display inline-block
    margin-right 5px

.delete-disabled
  opacity .3

  &.icon
    cursor inherit

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button
  -webkit-appearance none
  margin 0

input[type=number]
  -moz-appearance textfield

.modal-card .modal-card-foot
  -webkit-box-pack end
  -ms-flex-pack end
  justify-content flex-end

.modal-card .modal-card-title
  font-weight 600
  margin-bottom 0

.switch-column
  display flex
  @media screen and (max-width: 768px)
    margin-top 0
    padding-left 0
    align-items baseline
    .b-tooltip.is-left.is-info.b-tooltip-modal::before
      border-right 5px solid transparent
      border-bottom 5px solid #209cee
      border-left 5px solid transparent
      top calc(100% + 2px)
      right 2px
    .b-tooltip::after
      top 49px
      left -106px
.switch
  margin auto 0

.modal-card > span
  overflow auto

.field.has-addons >>> .is-info
  margin-top: 10px;
.column.switch-column
  justify-content end
.card-form.modal-card-body >>> span:first-child .field
  width 100%
  margin-bottom 0
.card-form.modal-card-body >>> span:first-child .switch-column
  min-width fit-content
  margin-top 20px
  padding-bottom 0
  padding-rigth 0
  .b-tooltip
    align-items center
.card-form.modal-card-body >>> span:first-child
  display flex
  justify-content space-between
  @media screen and (max-width: 768px)
    flex-wrap wrap
@media screen and (min-width: 768px)
  .column.switch-column >>> .b-tooltip
    align-items center
@media screen and (max-width: 768px)
  .column.switch-column
    margin-top: 0!important
    justify-content start
  .column.switch-column >>> .b-tooltip
    align-items normal
</style>
